module.exports = __webpack_public_path__ + "static/icon-pledge.fd93c5fe.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/icon-pledge.png
// module id = 984
// module chunks = 2